import { DynamicImage, Text } from 'components';
import React, { FC, useEffect } from 'react';
import styled from 'styled-components';
import { Question } from 'types/quiz';
import ContinueButton from './QuizContinueButton';
import { useQuizAnswers } from 'utils/hooks';
import { mobile, tablet } from 'styles/breakpoints';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
`;

const Title = styled(Text)`
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.625rem;
  text-align: center;
  margin-top: 1.5rem;
`;

const StyledDynamicImage = styled(DynamicImage)<{
  imageHeightDesktop: string;
  imageHeightTablet: string;
  imageHeightMobile: string;
}>`
  margin-top: 1.5rem;
  height: ${({ imageHeightDesktop }) => imageHeightDesktop};

  @media ${tablet} {
    height: ${({ imageHeightTablet }) => imageHeightTablet};
  }

  @media ${mobile} {
    height: auto;
  }
`;

interface Inset {
  question: Question;
  prevStep: number;
  currentStep: number;
  handleSkip: () => void;
  handleInsertQuestion: (key: string, value: string) => void;
  onContinue: (key: string, value: string) => void;
  handleBack: () => void;
}

const Insert: FC<Inset> = ({
  question,
  prevStep,
  currentStep,
  handleSkip,
  handleInsertQuestion,
  onContinue,
  handleBack,
}) => {
  const INSET_ANSWER_KEY = question.key + '_insert';

  const { answers } = useQuizAnswers();
  const previousAnswer = answers[question.key as keyof typeof answers]
    .toString()
    .split('|');

  const matchesAnswer = previousAnswer.some(item =>
    question.accept?.includes(item),
  );

  useEffect(() => {
    if (currentStep >= prevStep) {
      if (matchesAnswer) return;
      handleSkip();
    } else if (currentStep < prevStep) {
      if (matchesAnswer) return;
      handleBack();
    }
  }, []);

  if (!matchesAnswer) return null;
  return (
    <Container>
      <Title color="dark100">{question.title}</Title>
      {question.image && question.alt ? (
        <StyledDynamicImage
          src={question.image}
          alt={question.alt}
          imageHeightDesktop={question.imageHeightDesktop}
          imageHeightTablet={question.imageHeightTablet}
          imageHeightMobile={question.imageHeightMobile}
        />
      ) : null}
      <ContinueButton
        title={question.nextBtnTitle}
        onClick={() => onContinue(INSET_ANSWER_KEY, question.key)}
      />
    </Container>
  );
};

export default Insert;
